<template>
  <b-collapse
    :id="idCollapse"
    class="card-invite card-user"
    v-model="showCollapse"
  >
    <div class="card-invite-form">
      <input-component
        type="text-btn"
        icon="arrow-right"
        label=""
        btntype="btn-success"
        placeholder="Nome - CPF - E-mail "
        @inputactionclick="buscarComFiltro"
        @inputactionenter="buscarComFiltro"
      />
      <div class="flex">
        <v-date-picker
          :popover="{ visibility: 'click' }"
          mode="range"
          v-model="date"
          class="flex-grow"
          :columns="$screens({ default: 1, lg: 2 })"
          :max-date="new Date()"
        >
          <!--Custom Input Slot-->
          <input
            id="date"
            slot-scope="{ inputProps, inputEvents, isDragging }"
            :class="[
              `w-full py-2 px-3 ${
                isDragging ? 'text-gray-400' : 'text-gray-700'
              }`
            ]"
            v-bind="inputProps"
            placeholder="Selecione uma data"
            v-on="inputEvents"
            readonly="readonly"
          />
        </v-date-picker>
        <!--Clear Button-->
        <button
          type="button"
          class="bg-red-500 hover:bg-red-600 font-bold py-2 px-4 rounded-r"
          @click="date = null"
        >
          Limpar datas
        </button>
        <button
          type="button"
          class="bg-red-500 hover:bg-red-600 font-bold py-2 px-4 rounded-r"
          @click="resetFields"
        >
          Resetar campos
        </button>
      </div>
    </div>
    <table class="table table-hover table-responsive-md">
      <tbody>
        <tr v-for="tx in txs.list" v-bind:key="tx.id" class="d-flex">
          <td scope="row" class="col-2">
            <div>
              <router-link
                :to="{
                  name: 'CustomerServiceDetailsNew',
                  params: { txid: tx.uuid }
                }"
                ><strong>#{{ tx.id | numeral("00000") }}</strong></router-link
              >
            </div>
            <div class="subtitle">
              {{ tx.dateCreated | moment-date-dash }}
              {{ tx.dateCreated | moment-hour }}
            </div>
          </td>
          <td class="col-2">
            <img
              v-if="tx.profilePicture"
              :src="tx.profilePicture"
              class="img-avatar img-profile"
              style="height: 50px;"
            />
            <div>
              <div class="subtitle">
                <strong>{{ tx.buyerName }}</strong>
              </div>
              <div class="subtitle">{{ tx.amount | numeral("$ 0,0.00") }}</div>
            </div>
          </td>
          <td class="col-2">
            <div class="subtitle">{{ tx.buyerEmail }}</div>
            <div class="subtitle">{{ tx.buyerPhone }}</div>
          </td>
          <td class="col-2">
            <img
              height="50"
              :src="
                '/static/sellers/' +
                  tx.sellerName[0].toUpperCase() +
                  tx.sellerName
                    .toLowerCase()
                    .replace(/ /g, '_')
                    .slice(1) +
                  '.png'
              "
              class="img-profile"
            />
            <div>
              <div class="subtitle">
                <strong>{{ tx.sellerName }}</strong>
              </div>
              <div class="subtitle">{{ tx.reference }}</div>
            </div>
          </td>
          <td class="col-2">
            <div class="subtitle">
              <strong>{{ tx.status === 'AGE_RESTRICTION' ? 'MENOR DE IDADE' : tx.currentStep }}</strong>
            </div>
            <div
              class="subtitle"
              v-b-tooltip.hover
              title="Status na loja"
              v-if="tx.sellerStatus"
            >
              <i class="fa fa-shopping-cart"></i>
              <strong>{{ tx.sellerStatus }}</strong>
            </div>
          </td>
          <!--
          <td class="col-2">
            <button-component
              :href="
                'https://api.whatsapp.com/send?phone=55' +
                  tx.buyerPhone +
                  '&text=Olá ' +
                  tx.buyerName +
                  ', tudo bem? Seu parcelamento do pedido ' +
                  tx.id +
                  ' na ' +
                  tx.sellerName +
                  ' foi aprovado e este é o canal de suporte da boleto parcelado BoletoFlex. Aqui você pode tirar dúvidas sobre seu parcelamento, solicitar seus boletos e ' +
                  'nos informar se ocorrer algum problema com seu pedido. Mantendo seus pagamentos em dia, você garante todos os benefícios de proteção de sua compra. Para sua comodidade, ' +
                  'no link abaixo você tem acesso a todos boletos. Conte sempre com a gente. ' +
                  encodeURIComponent('https://meu.boletoflex.com/#/' + tx.uuid)
              "
              target="_blank"
              class="btn btn-outline-success"
            >
              <i class="micon-whatsapp"></i>
            </button-component>
          </td>
          -->
        </tr>
      </tbody>
    </table>
    <b-pagination
      size="md"
      align="center"
      :total-rows="total"
      v-model="currentPage"
      :per-page="max"
      @change="fetchData"
      limit="10"
    >
    </b-pagination>
  </b-collapse>
</template>

<script>
import Button from '../button/Button.vue'
import Input from '../form/Input.vue'
import moment from 'moment-timezone'

export default {
  props: {
    refreshList: {
      type: Boolean
    },
    orderList: {
      type: String
    },
    stepList: {
      type: String
    },
    showCollapse: {
      type: Boolean,
      default: true
    },
    idCollapse: {
      type: String,
      default: 'follow-up-list-collapse'
    },
    seller: {
      type: Number
    }
  },
  components: {
    'input-component': Input,
    'button-component': Button
  },
  data () {
    return {
      txs: [],
      currentPage: 1,
      max: 10,
      total: 0
    }
  },
  mounted () {
    this.fetchData(this.$cookie.get('currentPage') === null
      ? 1
      : parseInt(this.$cookie.get('currentPage')))
  },
  methods: {
    fetchData: function (val) {
      moment.locale('pt-br')
      var page = val || this.currentPage

      this.$cookie.set('currentPage', page, 1)
      var dataInicial = null
      var dataFinal = null
      if (this.date) {
        dataInicial = moment(this.date.start).format('YYYY-MM-DD')
        dataFinal = moment(this.date.end).format('YYYY-MM-DD')
      }
      var nameValue = this.name ? this.name : ''

      this.$http
        .get('api/customerservice', {
          params: {
            offset: this.max * (page - 1),
            max: this.max,
            name: nameValue,
            order: this.orderList,
            step: this.stepList,
            seller: this.seller,
            startdate: dataInicial,
            enddate: dataFinal
          }
        })
        .then(function (res) {
          console.log(res)
          this.txs = res.data
          this.total = res.data.total
          this.$nextTick(() => {
            this.currentPage = page
          })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    buscarComFiltro: function (filtro, item) {
      this.$store.dispatch('buscarComFiltro', filtro)
      this.currentPage = 1
      this.fetchData()
    },
    convertTime: function (val) {
      var seconds = Math.floor(val % 60).toString()
      var minutes = Math.floor(val / 60).toString()
      if (seconds.length === 1) {
        seconds = '0' + seconds
      }
      return minutes + 'm' + seconds + 's'
    },
    extractHostname: function (url) {
      var hostname

      if (url) {
        if (url.indexOf('://') > -1) {
          hostname = url.split('/')[2]
        } else {
          hostname = url.split('/')[0]
        }

        hostname = hostname.split(':')[0]
        hostname = hostname.split('?')[0]
      }

      return hostname
    },
    resetFields: function () {
      this.$store.dispatch('resetFields')
      document.getElementById('resetInput').value = ''
      this.currentPage = 1
      this.fetchData()
    }
  },
  computed: {
    name () {
      return this.$store.state.name
    },
    date: {
      get () {
        return this.$store.state.date
      },
      set (value) {
        this.$store.dispatch('buscarComData', value)
      }
    }
  },
  watch: {
    refreshList () {
      this.fetchData()
    },
    date () {
      this.fetchData()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variaveis.scss";
@import "../../../assets/scss/mixins.scss";
@import "../../../assets/scss/card.scss";

.card-user {
  .avatar {
    width: 40px;
  }
  .card-invite-body {
    top: 102px;
  }
}
.img-profile {
  float: left;
  margin-right: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/partial/customerservice/FollowUpListNew.vue